import { render } from "./BrowserSaver.vue?vue&type=template&id=436662de&scoped=true"
import script from "./BrowserSaver.vue?vue&type=script&lang=js"
export * from "./BrowserSaver.vue?vue&type=script&lang=js"

import "./BrowserSaver.vue?vue&type=style&index=0&id=436662de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436662de"]])

export default __exports__